import { UntypedFormBuilder, Validators } from '@angular/forms';
import { DatasetGeometryType } from 'src/app/model/dataset/dataset-geometry-type';
import { DatasetType } from 'src/app/model/dataset/dataset-type';
import { ColorScaleType } from '../model/dataset/rendering/color-scale-type';
import { Dataset } from '../model/dataset/dataset';
import { ShowInMap } from '../model/dataset/dataset-config-filter.enum';


export class OverlaysConstants {

    public static readonly  HIDE_GROUP_FROM_TABLE_COLUMNS_TAG = 'hide_from_table_columns';
    public static readonly NRI_EXTERNAL_DATASET_ID = "risk_index_tract";

}

export class CreateExternalOverlayControlsConfig {
    readonly externalDatasetKey = ['', Validators.required];
    readonly id = undefined;
    readonly datasetLabel = ['', Validators.required];
    readonly externalGroupId = ['', Validators.required];
    readonly trackable = [false, Validators.required];
    readonly fields = [[]];
    readonly providerEmail = [''];
    readonly showInMap = [ShowInMap.Filter_Panel];
    constructor(private readonly formBuilder: UntypedFormBuilder) {
    }
}

export class EditExternalOverlayControlsConfig {
    readonly externalDatasetKey = [this.dataset.externalDatasetKey, Validators.required];
    readonly id = [this.dataset.id];
    readonly datasetLabel = [this.dataset.datasetLabel, Validators.required];
    readonly fields = [this.dataset.fields];
    readonly externalGroupId = [this.dataset.externalGroupId];
    readonly trackable = [this.dataset.trackable];
    readonly providerEmail = [''];
    readonly showInMap = [this.dataset.showInMap];
    constructor(
        private readonly formBuilder: UntypedFormBuilder,
        private readonly dataset: Dataset
    ) {
    }
}

